import React, { useState } from "react";
import styles from "./Mixing.module.css";
import { Table, Tag } from "antd";
import {
  SearchInput,
  SubmitButton,
  TextComponent,
  Modal,
  InputField,
} from "../../../../components";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { SearchOutlined } from "@ant-design/icons";
import HeadingComponent from "../../../../components/HeadingComponent/HeadingComponent";
import { IoClose } from "react-icons/io5";

const Mixing = () => {
  const options = [
    { id: 1, name: "Ingredient" },
    { id: 2, name: "Components" },
    { id: 3, name: "Materials" },
  ];

  const [assignBaker, setAssignBakers] = useState(false);
  const [password, setPassword] = useState("");
  const [addMembers, setAddMembers] = useState(false);
  const [focused, setFocused] = useState(options[0]);
  const [onGoingTask, setOnGoingTask] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [taskDetailModal, setTaskDetailModal] = useState(false);
  const navigate = useNavigate();

  const taskDetails = [
    { id: 1, label: "Supervisor", text: "Trever Marks" },
    { id: 2, label: "Task Status", text: " Completed" },
    { id: 3, label: "Task Created", text: "01/09/2025 – 08:30 AM" },
    { id: 4, label: "Due Date", text: "01/09/2025 – 08:30 AM" },
    { id: 5, label: "Completed On", text: "01/09/2025 – 08:30 AM" },
    { id: 6, label: "Flour Lot", text: "F-BATCH-2306" },
    { id: 7, label: "Water Temperature", text: "Room Temperature (70-77° F)" },
    { id: 8, label: "Mixing Time", text: "8 - 10 minutes " },
    { id: 10, label: " Dough Temperature (Post-Mix)", text: "(75-78° F)" },
    { id: 11, label: "Hydration Adjustment ", text: "None " },

    { id: 12, label: "Flagged Issue", text: "None " },
    { id: 13, label: "Assigned To", text: "John Doe, Ethan, Noah, Mason" },
  ];

  const [modalArr, setModalArr] = useState([
    "John Smith",
    "John Smith",
    "John Smith",
    "John Smith",
  ]);

  const columns = [
    {
      title: "Task ID",
      dataIndex: "OrderID",
      key: "OrderID",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "Task Name",
      dataIndex: "TaskName",
      key: "TaskName",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },

    {
      title: "Start Time",
      key: "StartTime",
      dataIndex: "StartTime",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },

    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (status) => {
        let color = "default";
        switch (status) {
          case "Pending":
            color = "#FF0000";
            break;
          case "In Progress":
            color = "#F7630C";
            break;
          case "Completed":
            color = "#008000";
            break;
          default:
            color = "#000000";
        }
        return (
          <TextComponent
            style={{ color: color }}
            text={status}
            padding={"0px"}
            // color={color}
            fontFamily={"Inter-semiBold"}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        const { Status } = record;

        if (Status === "Completed") {
          return (
            <SubmitButton
              title=" Review Task"
              primary
              onClick={() => setTaskDetailModal(true)}
            />
          );
        }

        if (Status === "Pending" || Status === "In Progress") {
          return (
            <>
              <div className={styles.Tablebtn}>
                <button
                  className={styles.TableButton1}
                  // onClick={() => navigate("/Staff/RecipeProduction/Assign")}
                  onClick={() => setAssignBakers(true)}
                >
                  Assign
                </button>
                <button
                  className={styles.TableButton}
                  onClick={() =>
                    navigate("/staff/RecipeProduction/OngoingTask")
                  }
                >
                  Start Task
                </button>
              </div>
            </>
          );
        }

        return null;
      },
    },
  ];
  const ongoingColumns = [
    {
      title: "Task ID",
      dataIndex: "TaskID",
      key: "TaskID",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "Task Name",
      dataIndex: "TaskName",
      key: "TaskName",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];

  const data = [
    {
      OrderID: "#153485",
      TaskName: "Choc Chip Cookie",
       StartTime: "8:00 Am",
      // AssignedTo: "John Smith",
      Status: "Completed",
      DueDate: "Aug 01, 2025",
    },
    {
      OrderID: "#153485",
      TaskName: "Choc Chip Cookie",
       StartTime: "8:00 Am",
      // AssignedTo: "John Smith",
      Status: "In Progress",
      DueDate: "Aug 01, 2025",
    },
    {
      OrderID: "#153485",
      TaskName: "9-Grain Pullman",
       StartTime: "8:00 Am",
      // AssignedTo: "John Smith",
      Status: "Pending",
      DueDate: "Aug 01, 2025",
    },
    {
      OrderID: "#153485",
      TaskName: "9-Grain Pullman",
       StartTime: "8:00 Am",
      // AssignedTo: "John Smith",
      Status: "In Progress",
      DueDate: "Aug 01, 2025",
    },
    {
      OrderID: "#153485",
      TaskName: "9-Grain Pullman",
       StartTime: "8:00 Am",
      // AssignedTo: "John Smith",
      Status: "Pending",
      DueDate: "Aug 01, 2025",
    },
    {
      OrderID: "#153485",
      TaskName: "Choc Chip Cookie",
       StartTime: "8:00 Am",
      // AssignedTo: "John Smith",
      Status: "In Progress",
      DueDate: "Aug 01, 2025",
    },
    {
      OrderID: "#153485",
      TaskName: "Choc Chip Cookie",
       StartTime: "8:00 Am",
      // AssignedTo: "John Smith",
      Status: "Pending",
      DueDate: "Aug 01, 2025",
    },
  ];

  const ongoingData = [
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/staff/RecipeProduction/OngoingTask")}
        />
      ),
    },
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/staff/RecipeProduction/OngoingTask")}
        />
      ),
    },
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/staff/RecipeProduction/OngoingTask")}
        />
      ),
    },
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/staff/RecipeProduction/OngoingTask")}
        />
      ),
    },
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/staff/RecipeProduction/OngoingTask")}
        />
      ),
    },
  ];

  return (
    <div className={styles.MainDiv}>
      {/* <div className={styles.InputHeader}>
        <div className={styles.SearchInput}>
          <SearchInput
            placeholder="Search..."
            rightIcon={<SearchOutlined />}
            className={`${searchInputStyle} ${styles.searchInput}`}
             onChange={onSearch}
          />
        </div>
        <div className={styles.SearchButton}>
          <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            secondary
            title={"Ongoing Tasks"}
            onClick={() => {
              setOnGoingTask(true);
            }}
          />
          <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            primary
            title={"Orders Checklist"}
            onClick={() => {
              navigate("/Staff/OrderChecklist");
            }}
          />
        </div>
      </div> */}

      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
        />
      </div>

      {/* //////////////////Assign baker///////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={assignBaker}
        onCancel={() => {
          setAssignBakers(false);
        }}
        // onClickOkButton={() => {
        //   setPasswordModal(true);
        //   setAssignBakers(false);
        // }}
        // onClickCancelButton={() => {
        //   setAssignBakers(false);
        // }}
        className={styles.Modal}
        // okBtnTitle={"Edit"}
        // cancelBtnTitle={"Cancel"}
        // width={"90%"}
        // twoButton
        // onBtnPress={() => setAssignBakers(false)}
      >
        <HeadingComponent
          text={"Assigned Staff"}
          className={styles.modalHead}
        />
        <div className={styles.modalArrDiv}>
          {modalArr?.map((item, index) => (
            <div className={styles.modalArrItem}>
              <img
                className="sidebarIcon"
                src={require("../../../../assets/images/recipeProductionMember.jpg")}
                alt=""
              />
              <TextComponent text={item} />
            </div>
          ))}
        </div>
      </Modal>

      {/* ////////////////////////password modal ///////////////// */}
      <Modal
        open={passwordModal}
        onCancel={() => {
          setPasswordModal(false);
        }}
        onClickOkButton={() => {
          setPasswordModal(false);
          setAddMembers(true);
        }}
        className={styles.modalCont}
        title={"Enter Staff Password"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickCancelButton={() => setPasswordModal(false)}
        type={"password"}
        // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <InputField
          placeholder={"12*******"}
          innerInput={{ width: "" }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>

      {/* ////////////////////////// Add Assign bakers //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={addMembers}
        onCancel={() => {
          setAddMembers(false);
        }}
        onClickOkButton={() => {
          setAddMembers(false);
        }}
        onClickCancelButton={() => {
          setAddMembers(false);
        }}
        className={styles.Modal}
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        // width={"90%"}
        twoButton
        onBtnPress={() => setAddMembers(false)}
      >
        <HeadingComponent
          text={"Assigned Staff"}
          className={styles.modalHead}
        />
        <SearchInput
          rightIcon={<SearchOutlined />}
          placeholder={"Search Lot"}
        />
        <div className={styles.modalArrDiv}>
          {modalArr?.map((item, index) => (
            <div className={styles.modalArrItem}>
              <img
                className="sidebarIcon"
                src={require("../../../../assets/images/recipeProductionMember.jpg")}
                alt=""
              />
              <TextComponent text={item} />
              <IoClose
                size={20}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  let arr = [...modalArr];
                  const result = arr.filter((_, i) => i !== index);
                  setModalArr(result);
                }}
              />
            </div>
          ))}
        </div>
      </Modal>

      {/* ////////////////////////// Ongoing Tasks //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={onGoingTask}
        onCancel={() => {
          setOnGoingTask(false);
        }}
        className={styles.Modal}
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        // width={"90%"}
        onBtnPress={() => setAddMembers(false)}
      >
        <HeadingComponent text={"Ongoing Tasks"} className={styles.modalHead} />
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={ongoingColumns}
            dataSource={ongoingData}
            pagination={false}
          />
        </div>
      </Modal>

      {/* taskDetailModal  */}
      <Modal
        open={taskDetailModal}
        onCancel={() => {
          setTaskDetailModal(false);
        }}
        onClickOkButton={() => {
          setTaskDetailModal(false);
        }}
        className={styles.modalCont}
        title={"Task Details"}
        headingClass={styles.modalHeading}
        width={"400px"}
        onClickCancelButton={() => setTaskDetailModal(false)}
        type={"password"}
        // onBtnPress={() => setLimitExceedsModal(false)}
      >
        {taskDetails.map((item) => (
          <div className={styles.taskDetail}>
            <TextComponent text={item.label} className={styles.tastText} />
            <TextComponent text={item.text} />
          </div>
        ))}
      </Modal>
    </div>
  );
};

export default Mixing;
